/** @internal */
export const Slugs = Object.freeze({
  advanced: 'control.editor.advanced'
});
